<div class="allergens-wrapper">
  <p id="allergensTitle" class="ods-typography-subtitle-l">{{ 'do_you_have_any_allergy' | translate }}</p>
  <p class="ods-typography-body-m-regular">
    {{ 'if_you_have_allergies_contact_with_shop' | translate }}
    <a class="ods-typography-body-m-regular" [attr.href]="'tel:' + shopPhone">+30 {{ shopPhone }}</a
    >. {{ 'shop_will_give_you_all_info' | translate }}
  </p>
</div>
